import { create } from 'zustand';
import type { TPoint } from '../api/types';

type IPoint = {
	lat: number;
	lon: number;
};

type IBounds = {
	max: IPoint;
	min: IPoint;
};

export interface IGeoCity {
	spawnPoint: IPoint;
	bounds?: IBounds;
	nameCity?: string;
}

type GeoState = {
	bounds: IBounds | null;
	clearGeo: () => void;
	country: { id: number; name: string } | null;
	manualLocation: TPoint | null;
	nameCity: string | null;
	setCountry: (id: number, name: string) => void;
	setGeo: (city: IGeoCity) => void;
	setManualLocation: (lat: number, lng: number) => void;
	spawnPoint: IPoint | null;
};

export const useGeoStore = create<GeoState>((set) => ({
	bounds: null,
	clearGeo: () => set({ bounds: null, country: null, nameCity: null, spawnPoint: null }),
	country: null,
	manualLocation: null,
	nameCity: null,
	setCountry: (id, name) => set({ country: { id, name } }),
	setGeo: (city) =>
		set({
			bounds: city.bounds,
			nameCity: city.nameCity,
			spawnPoint: city.spawnPoint,
		}),
	setManualLocation: (lat, lng) => set({ manualLocation: { lat, lng } }),
	spawnPoint: null,
}));
